import React from 'react';
import { get } from "lodash"

import ParamsBlock from "./paramsBlock"
import { lbsToKg } from "./../../../utils/converter"
import { currentWeightTypeData } from "./../currentWeight/static.currentWeightData"
import locales from "./../../../content.json"

import styles from "./waterResultBlock.module.scss"

const MIN_VALUE = 1
const MAX_VALUE = 5
const WATER_MIN_COEFICIENT = 0.03
const WATER_MAX_COEFICIENT = 0.035

const inRange = value => {
  return value < MIN_VALUE
    ? MIN_VALUE
    : value > MAX_VALUE
      ? MAX_VALUE
      : value
}

const WaterResultBlock = props => {
  const { data } = props
  const currentWeightKg = get(data, ["currentWeight", "type"]) === currentWeightTypeData.lbs.value
    ? lbsToKg(get(data, ["currentWeight", "value"]))
    : get(data, ["currentWeight", "value"])

  const minWater = parseFloat((WATER_MIN_COEFICIENT * currentWeightKg).toFixed(2))
  const maxWater = parseFloat((WATER_MAX_COEFICIENT * currentWeightKg).toFixed(2))

  const left = (inRange(minWater) - MIN_VALUE) / (MAX_VALUE - MIN_VALUE) * 100
  const right = (inRange(maxWater) - MIN_VALUE) / (MAX_VALUE - MIN_VALUE) * 100
  const width = right - left

  return (
    <ParamsBlock
      title={locales[window.userLang].water}
      helpText={<span>{locales[window.userLang].recommended_water}</span>}
      value={`${minWater}-${maxWater}L`}
    >
      <div className={styles.waterGrafic}>
        <div className={styles.categoryLine}>
          <span style={{ width: width + "%", left: left + "%" }}></span>
        </div>
        <div className={styles.graficValues}>
          <span>{MIN_VALUE} L</span>
          <span>{MAX_VALUE} L</span>
        </div>
      </div>
    </ParamsBlock>
  )
}

export default WaterResultBlock;